import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'
import { App, boot } from './app'
import { registerServiceWorker } from './pwa/register'
import { captureInstallPrompt } from './pwa/install'

captureInstallPrompt()

const root = createRoot(document.getElementById('root')!)
void boot().then((b) => {
  root.render(
    <StrictMode>
      <App boot={b} />
    </StrictMode>,
  )
})

if (document.readyState === 'complete') void registerServiceWorker()
else window.addEventListener('load', () => void registerServiceWorker(), { once: true })
